import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import PaymentGetewayItem from "./Item";
import BazaarBilling from "../PaymentBazar";
import { checkBazaarSDK } from "../../../redux/action/baseData/baseAction";
import { useDispatch, useSelector } from "react-redux";

const PaymentGetewayItems = () => {
  const location = useLocation();
  const hasBazaarSDK = useSelector((state) => state.baseData.bazar_connection);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(checkBazaarSDK());
  }, []);

  return (
    <ul className="sm:grid sm:grid-cols-2 flex flex-col gap-8 w-full">
      {hasBazaarSDK ? (
        <BazaarBilling bazaar={location.state?.bazaar} />
      ) : (
        location.state?.urls?.map((item) => (
          <PaymentGetewayItem
            key={item.url}
            homeLogo={item.title === "zarinpal" || item.title === "sep"}
            logo={
              item.title === "zarinpal"
                ? "zarinpal"
                : item.title === "sep"
                  ? "sep"
                  : item.logo
            }
            title={
              item.title === "zarinpal"
                ? "زرین‌پال"
                : item.title === "sep"
                  ? "سامان کیش"
                  : item.title
            }
            url={item.url}
          />
        ))
      )}
    </ul>
  );
};

export default PaymentGetewayItems;
